

module.exports = __webpack_require__.stylable.create(
    "Loader519697049",
    {"classes":{"root":"Loader519697049__root","bgColor":"Loader519697049__bgColor","spinnerWrapper":"Loader519697049__spinnerWrapper","spinner":"Loader519697049__spinner","path":"Loader519697049__path","preLoaderTextWrapper":"Loader519697049__preLoaderTextWrapper","preLoaderTitleWrapper":"Loader519697049__preLoaderTitleWrapper","preLoaderTitle":"Loader519697049__preLoaderTitle","preLoaderSubTitle":"Loader519697049__preLoaderSubTitle"},"vars":{},"stVars":{"DefaultTextFont":"\"{theme: 'Heading-M', size: '24px', lineHeight: '24px'}\"","DefaultSubTextFont":"\"{theme: 'Heading-M', size: '16px', lineHeight: '16px'}\"","PreLoaderTextColor":"\"fallback(color(--eventTitleColor), color(color-5))\""},"keyframes":{"dash":"Loader519697049__dash"}},
    "",
    16,
    "Loader519697049",
    null
);
